// LICENSE : MIT
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReduceState_1 = require("./ReduceState");
exports.ReduceState = ReduceState_1.ReduceState;
var ReduceStore_1 = require("./ReduceStore");
exports.ReduceStore = ReduceStore_1.ReduceStore;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-reduce-store/lib/index.js
// module id = 69
// module chunks = 0